import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaBars,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaTimes,
  FaUser,
  FaWhatsapp,
} from "react-icons/fa";
import { logo } from "../views/static";

const links = [
  ["/", "Página Inicial"],
  ["/sobre", "Sobre Nós"],
  ["/servicos", "Nossos Serviços"],
  ["/cursos", "Cursos Disponíveis"],
  // ["/portfolio", "Portfólio"],
  ["/blog", "Notícias"],
  ["/contato", "Contacto"],
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="top-strip bg-warning">
        <div className="site-container top-strip-inner ">
          <div className="contact-mini text-dark">
            <a href="tel:+24493328889">
              <FaPhoneAlt /> +244 933 288 89
            </a>
            <a href="mailto:cenfotep@outlook.com">
              <FaEnvelope /> cenfotep@outlook.com
            </a>
          </div>
          <div className="top-actions">
            <a href="https://facebook.com/cenfotep" aria-label="Facebook" className="text-dark">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com/cenfotep" aria-label="Instagram" className="text-dark">
              <FaInstagram />
            </a>
            <a href="https://wa.me/24493328889" aria-label="WhatsApp" className="text-dark">
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
      <header className="site-header">
        <div className="site-container nav-shell">
          <Link className="brand" to="/" onClick={() => setOpen(false)}>
            <span className="brand-mark">
              <img src={logo} alt="" />
            </span>
            <span>
              <strong>CENFOTEP</strong>
              <small>Tecnologia & Formação</small>
            </span>
          </Link>
          <button
            className="menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Abrir menu"
          >
            {open ? <FaTimes /> : <FaBars />}
          </button>
          <nav className={open ? "main-nav is-open" : "main-nav"}>
            {links.map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {label}
              </NavLink>
            ))}
            <a
              className="nav-cta"
              onClick={() => setOpen(false)}
            >
              Login <FaUser />
            </a>
          </nav>
        </div>
      </header>
    </>
  );
}